/**
 * This is 1:1 mapping from the SoftwareFeature class.
 *
 * @see app/SoftwareFeature.php for PHP mapping
 */
export enum SoftwareFeature {
  UserManagement = 'user_management',
  TeamNotifications = 'team_notifications',
  AnalysisDashboard = 'analysis_dashboard',
  EstimatingDashboard = 'estimating_dashboard',
  AccountingDashboard = 'accounting_dashboard',
  LeadsDashboard = 'leads_dashboard',
  ActiveProjectsDashboard = 'active_projects_dashboard',
  PortfolioDashboard = 'portfolio_dashboard',
  ProjectNotes = 'project_notes',
  FlipAnalyzer = 'flip_analyzer',
  RentalAnalyzer = 'rental_analyzer', // BRRRR Analyzer
  RepairEstimator = 'repair_estimator',
  DealAnalysisReports = 'deal_analysis_reports',
  TaskManager = 'task_manager',
  ProjectScheduler = 'project_scheduler',
  ProjectCalendar = 'project_calendar',
  ProjectBudgeter = 'project_budgeter',
  ExpenseTracker = 'expense_tracker',
  IncomeTracker = 'income_tracker',
  AccountingReports = 'accounting_reports',
  ContactsVendors = 'contacts_vendors', // Companies & Contacts
  ProjectDocuments = 'document_manager',
  PhotoLog = 'photo_log',
  AddProjects = 'add_or_delete_project',
  DeleteProjects = 'delete_project',
  MaterialCatalog = 'material_catalog',
  ProjectComps = 'project_comps',
  ProjectProgressUpdates = 'project_progress_updates',
  PropertySearch = 'property_search',
  ActivityLog = 'activity_log',
  CustomNavbarLogo = 'custom_navbar_logo',
}
